module.exports = __webpack_public_path__ + "static/rivella_droplets-f3fd67375a32bbc4d0de0f0b1c12eec2.mp4";